'use client';

import { useEffect, useState } from 'react';
import { HeaderBanners } from './components/header-banners';
import { PingwinHeader } from './index';
import { useIsAuth } from '@/shared/providers/user-provider/use-user';
import styles from './server-header.module.css';

export const HeaderRightSlot = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return <div className={styles.rightSlot} data-header-right-slot="true" />;
  }

  return <PingwinHeader />;
};

export const HeaderBannersSlot = () => {
  const isAuth = useIsAuth();

  return isAuth ? <HeaderBanners /> : null;
};
